import alt from 'framework/alt';

class WeblabStore {
  constructor() {
    this.state = {
      weblabs: [],
    };

    this.on('bootstrap', () => {
      const { weblabs } = this.state;

      this.setState({
        weblabs,
      });
    });
  }
}

export default alt.createStore(WeblabStore, 'WeblabStore');
